import React, { useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { toast } from "react-toastify";

const RedirectScreen = () => {
  useEffect(() => {
    const redirectToAppStore = () => {
      window.location.href = "itms-apps://apps.apple.com/app/id6455429167";
      setTimeout(() => {
        window.location.href = "https://apps.apple.com/in/app/insugo-digi/id6455429167"; 
      }, 1000);
    };

    const redirectToPlayStore = () => {
      window.location.href = "market://details?id=in.insugo.digi";
      setTimeout(() => {
        window.location.href = "https://play.google.com/store/apps/details?id=in.insugo.digi";
      }, 1000);
    };

    if (isAndroid) {
      toast("Redirecting to Play Store...");
      redirectToPlayStore();
    } else if (isIOS) {
      toast("Redirecting to App Store...");
      setTimeout(redirectToAppStore, 500);
    } else {
      toast("Redirecting to login...");
      window.location.href = "/login";
    }
  }, []);

  return null; 
};

export default RedirectScreen;
